import { Link } from 'react-scroll';

import { AiOutlineClose } from 'react-icons/ai';

import './styles.css';

const Sidebar = ({handleTrigger, isOpen}) =>{
  return(
      <div
      className={isOpen?"sidebarActive sidebar bg-primary align-items-center flex-column":
      "sidebarDesactive sidebar bg-primary align-items-center flex-column"}>
        {isOpen &&
        <>
        <div className="container d-flex justify-content-end p-4">
          <AiOutlineClose
          onClick={handleTrigger}
          style={{fill: 'white'}}
          size={20}
          className="closeIcon"
          />
        </div>
        <div className="division2 col-10">
          <Link
          onClick={handleTrigger}
          to="home"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.4s'}}>
            <h5 className="font-weight-bold">
              Home
            </h5>
          </Link>
          <Link
          onClick={handleTrigger}
          to="features"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.5s'}}>
            <h5 className="font-weight-bold">
              Features
            </h5>
          </Link>
          <Link
          onClick={handleTrigger}
          to="screenshots"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.6s'}}>
            <h5 className="font-weight-bold">
              Screenshots
            </h5>
          </Link>
          <Link
          onClick={handleTrigger}
          to="blog"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.7s'}}>
            <h5 className="font-weight-bold">
              Blog
            </h5>
          </Link>
          <Link
          onClick={handleTrigger}
          to="pricing"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.8s'}}>
            <h5 className="font-weight-bold">
              Pricing
            </h5>
          </Link>
          <Link
          onClick={handleTrigger}
          to="contact"
          smooth="true"
          className="row text-white sidebarItem d-flex justify-content-center align-items-center mt-3"
          style={{animationDelay: '0.9s'}}>
            <h5 className="font-weight-bold">
              Contact
            </h5>
          </Link>
        </div>
        </>
        }
      </div>
  )
}
export default Sidebar;